<template>
  <v-card class="overflow-hidden">
    <v-app-bar absolute color="white">
      <v-app-bar-nav-icon></v-app-bar-nav-icon>
      <v-toolbar-title>Capture Webcam App</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon>
        <v-icon>mdi-dots-vertical</v-icon>
      </v-btn>
    </v-app-bar>
    <v-sheet id="scrolling-techniques-7">
      <v-container style="height: 55px"> </v-container>
    </v-sheet>
  </v-card>
</template>

<script>
export default {
  name: 'Navbar',
}
</script>
